import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { Button, Card, CardActions, CardContent, Grid, Typography } from '@material-ui/core';
import { useProperties, useFields, useOrganizations } from 'hooks';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: { overflow: 'visible' },
  alert: {
    marginBottom: theme.spacing(3),
  },
  formGroup: {
    marginBottom: theme.spacing(3),
    width: '100%',
    flexGrow: 1,
  },
  formGroupGrid: {
    marginBottom: theme.spacing(3),
    flexGrow: 1,
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
  },
  fieldHint: {
    margin: theme.spacing(1, 0),
  },
  addButton: {
    marginLeft: theme.spacing(1),
  },
  tags: {
    marginTop: theme.spacing(1),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  modal: {
    position: 'fixed',
    top: '5px',
    right: '5px',
    width: '50%',
    backgroundColor: 'rgb(255,255,255, 1)',
    boxShadow: 24,
  },
  modalActionCancel: {
    marginLeft: '2%',
  },
  modalActionPrimary: {
    marginLeft: '5%',
  },
  srcClickLink: { textDecoration: 'underline', color: 'blue', cursor: 'pointer' },
}));

const DeviceDetails = ({ device, hide }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { organizations } = useOrganizations();
  const { properties } = useProperties();
  const { fields } = useFields();
  const orgFind = _.find(organizations, { id: device.organization_id });
  const propFind = _.find(properties, { id: device.property_id });
  const fieldFind = _.find(fields, { id: device.field_id });

  return (
    <Card className={classes.modal}>
      <CardContent>
        <Grid container padding={2}>
          <Grid item container xs={6}>
            <Typography>{t('name')}</Typography>
          </Grid>
          <Grid item container xs={6}>
            <Typography>{device?.name}</Typography>
          </Grid>

          <Grid item container xs={6}>
            <Typography>{t('hw_address')}</Typography>
          </Grid>
          <Grid item container xs={6}>
            <Typography>{device?.hw_address}</Typography>
          </Grid>

          <Grid item container xs={6}>
            <Typography>{t('organization')}</Typography>
          </Grid>
          <Grid item container xs={6}>
            <Typography>{orgFind && orgFind.name}</Typography>
          </Grid>

          <Grid item container xs={6}>
            <Typography>{t('property')}</Typography>
          </Grid>
          <Grid item container xs={6}>
            <Typography>{propFind && propFind.name}</Typography>
          </Grid>

          <Grid item container xs={6}>
            <Typography>{t('field')}</Typography>
          </Grid>
          <Grid item container xs={6}>
            <Typography>{fieldFind && fieldFind.name}</Typography>
          </Grid>
        </Grid>
        <CardActions>
          <Button onClick={hide} color="primary">
            {t('close')}
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  );
};

DeviceDetails.propTypes = {
  hide: PropTypes.func,
  device: PropTypes.object,
};

DeviceDetails.defaultProps = {
  hide: () => {},
  device: {},
};

export default DeviceDetails;
